const boostDetails = {
  pdsButton: 'Read our PDS',
  specifiedItems: {
    title_one: 'My specific items ({{count}} Item)',
    title_other: 'My specific items ({{count}} Items)',
    subtotal: 'Sub Total',
    primaryButton: {
      add: 'Add Item',
      remove: 'Remove all',
    },
  },
  boostHeader: {
    primaryButton: {
      add: 'Add to Trip',
      mandatory: 'Mandatory',
      limit: 'Select Limit',
      removeAll: 'Remove All',
      remove: 'Remove',
      addItem: 'Add Item',
      payPerDayEdit: 'Edit Days',
      payPerDaySelect: 'Select Days',
      notEligible: 'Not eligible',
    },
    secondaryButton: {
      remove: 'Remove',
    },
  },
  modal: {
    actions: {
      details: 'Details',
    },
  },
  extraCancellationModal: {
    actions: {
      addItem: 'Add Item',
      addTrip: 'Add to Trip',
    },
  },
} as const;

export default boostDetails;
